// Procesarea imaginilor pe telefon (gratuit — fără Cloudflare Images):
// decupare 2:3 → copertă max 600×900 (JPEG ~60 KB) + miniatură 200×300 (~12 KB) → upload în D1.
import { apiJson, authHeaders } from './http';

export interface Crop { x: number; y: number; w: number; h: number } // în pixeli naturali

export async function blobToBitmap(blob: Blob): Promise<ImageBitmap> {
  try { return await createImageBitmap(blob, { imageOrientation: 'from-image' } as any); }
  catch { return await createImageBitmap(blob); }
}

function draw(bmp: ImageBitmap, crop: Crop, maxW: number, maxH: number, quality: number) {
  const scale = Math.min(1, maxW / crop.w, maxH / crop.h);
  const w = Math.max(1, Math.round(crop.w * scale)), h = Math.max(1, Math.round(crop.h * scale));
  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d')!;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(bmp, crop.x, crop.y, crop.w, crop.h, 0, 0, w, h);
  return { dataUrl: canvas.toDataURL('image/jpeg', quality), w, h };
}

export function fullCrop(bmp: ImageBitmap): Crop { return { x: 0, y: 0, w: bmp.width, h: bmp.height }; }

export async function uploadCover(bmp: ImageBitmap, crop: Crop, opts: { workId?: string; source: string; sourceUrl?: string }): Promise<string> {
  const big = draw(bmp, crop, 600, 900, 0.82);
  const thumb = draw(bmp, crop, 200, 300, 0.72);
  const r = await apiJson<{ url: string }>('/api/covers', {
    method: 'POST',
    body: JSON.stringify({ work_id: opts.workId, image: big.dataUrl, thumb: thumb.dataUrl, width: big.w, height: big.h, source: opts.source, source_url: opts.sourceUrl })
  });
  return r.url;
}

// Descarcă o imagine externă prin serverul nostru (ocolește blocajele CORS/hotlink ale librăriilor)
export async function fetchRemoteImage(url: string): Promise<Blob> {
  const res = await fetch(`/api/covers/fetch?url=${encodeURIComponent(url)}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Imaginea nu poate fi descărcată (${res.status})`);
  return res.blob();
}

// Miniatura pentru grilă: coperțile noastre au variantă _t; cele externe rămân ca atare
export function thumbUrl(coverUrl?: string | null): string | null {
  if (!coverUrl) return null;
  const m = /^\/img\/([a-f0-9]{32})\.(jpg|png|webp)$/.exec(coverUrl);
  return m ? `/img/${m[1]}_t.jpg` : coverUrl;
}
